/*
 *
 * NewTreatmentResultStep constants
 *
 */
import { getPractice } from "utils/practiceStorage";

export const DEFAULT_ACTION = "app/NewTreatmentResultStep/DEFAULT_ACTION";

/**
 * Plan activity
 */
export const PLAN_ACTIVITY = "app/NewTreatmentResultStep/PLAN_ACTIVITY";
export const PLAN_ACTIVITY_FAILED =
  "app/NewTreatmentResultStep/PLAN_ACTIVITY_FAILED";
export const PLAN_ACTIVITY_SUCCESS =
  "app/NewTreatmentResultStep/PLAN_ACTIVITY_SUCCESS";

/**
 * urls
 */
export function PLAN_ACTIVITY_URL() {
  return `/practices/${getPractice().id}/planActivity`;
}

export function PLAN_ACTIVITY_RESULT_URL() {
  return `/practices/${getPractice().id}/planActivityResult`;
}
